import React from 'react';
import PageContainer from '../../../layout/PageContainer';
import ConsolidadoCredito from './ConsolidadoCredito';

const ConsolidadoCreditoContainer = () => {
  return (
    <PageContainer
      breadcrumbs={[
        { id: 0, name: 'SEGURO DE CRÉDITO', url: '/' },
        { id: 1, name: 'ASEGURADO', url: '/asegurado/polizas-credito' },
        { id: 2, name: 'CONSOLIDADO CRÉDITO' },
      ]}
      clientFilter={{
        type: 'asegurado',
        ramo: 'credito',
        showFilter: true,
      }}
    >
      {(client) => <ConsolidadoCredito client={client} />}
    </PageContainer>
  );
};

export default ConsolidadoCreditoContainer;
